import { useEffect, useLayoutEffect } from "react";
import { goToPageV2, navHide } from "@/utils/common";
import "./index.less";
import Page from "./page";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import useFetchConfigPage from "@/hooks/useConfigPage/useFetchConfigPage";
import { ConfigPageProvider } from "@/hooks/useConfigPage/useConfigPage";
import { getQueryHashString } from "@/utils/url";
import ScrollContainer from "./ScrollContainer";
import AppNavBarWithConfig from "@/hooks/useConfigPage/AppNavBarWithConfig";

const ConfigPage = () => {
  useLayoutEffect(() => {
    // 隐藏导航栏
    navHide();
  }, []);

  useEffect(() => {
    // 监听 hash 变化
    const handleHashChange = () => {
      window?.location?.reload();
    };

    const handleNavHide = () => {
      navHide();
      setTimeout(() => {
        navHide();
      }, 100);
    }; // 100 毫秒内最多执行一次

    window.addEventListener("hashchange", handleHashChange);
    document.addEventListener("visibilitychange", handleNavHide);

    // 清理事件监听器
    return () => {
      document.removeEventListener("visibilitychange", handleNavHide);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  // 分享逻辑已封装到ConfigPageProvider中

  const pageCode = getQueryHashString("pageCode") || "";
  const versionCode = getQueryHashString("versionCode") || "";
  const query = useFetchConfigPage({
    pageCode,
    versionCode,
  });

  useEffect(() => {
    // 监听页面数据变化
    if (query?.status === "success") {
      if (!query?.data?.moduleList || query?.data?.moduleList.length === 0) {
        goToPageV2({
          hash: "/expiredPage",
          params: {
            expiredTitle: query?.data?.emptyTips || "",
          },
          isReplace: true,
        });
      }
    }
  }, [query]);

  useEffect(() => {
    // 监听页面数据变化
    if (query?.data?.pageTitle) {
      document.title = query?.data?.pageTitle;
    }
  }, [query?.data?.pageTitle]);

  return (
    <div className="config_pageCntainer">
      <ConfigPageProvider configPageQuery={query}>
        <AppNavBarWithConfig />
        <ScrollContainer>
          <Page />
        </ScrollContainer>
      </ConfigPageProvider>
    </div>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigPage />
    </QueryClientProvider>
  );
};
export default App;
